// HOA-8305: centralize plan currency logic so the JMD/USD (J$) branching is not
// duplicated across the commission-summary components. Currency is driven by the
// plan country when available, falling back to the legacy sales-channel signal.

export type CurrencyInfo = { code: string, symbolOverride?: string };

export function getCurrencyInfo(country?: string, salesChannel?: string): CurrencyInfo {
  const isJamaica = (country && country.toUpperCase() === 'JM')
    || (!country && salesChannel === 'Jamaica');

  if (isJamaica) {
    return { code: 'JMD', symbolOverride: 'J$' };
  }
  return { code: 'USD' };
}

/**
 * Normalizes a backend-formatted money string to a plan's currency-symbol override.
 * Per-row money cells come from the backend as USD "$..." (Postgres ::money or a
 * hardcoded "$"); when the plan's currency resolves to an override (e.g. JMD -> "J$"),
 * prefix the first "$" so rows match the client-formatted totals row.
 *
 * No-op when there is no override, the value is not a string, contains no "$", or
 * already carries the override (prevents double-prefixing, e.g. "J$" -> "JJ$").
 */
export function applyCurrencySymbolOverride(value: unknown, symbolOverride?: string): unknown {
  if (
    symbolOverride &&
    typeof value === 'string' &&
    value.indexOf('$') !== -1 &&
    value.indexOf(symbolOverride) === -1
  ) {
    return value.replace('$', symbolOverride);
  }
  return value;
}
